// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QrLo","message":"styles_message__q_zld","loader":"styles_loader__1VvZ9"};